import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ChartOptions, ChartType } from 'chart.js';
import { Output, Input, EventEmitter } from '@angular/core';
import { AnalyticsService } from '../../services/api';
import { NgxChartsModule, ScaleType } from '@swimlane/ngx-charts';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'subject-report',
	templateUrl: 'subject-report.component.html',
	styleUrls: ['subject-report.component.scss'],
	providers: [DatePipe]
})

export class SubjectReportComponent implements OnInit, OnChanges {
	@Input() deviceId:number = -1;
	@Input() schoolId:number = -1;
	@Input() projectId:number | undefined = -1;
	@Input() outstartDate: Date = new Date();
	@Input() outendDate: Date = new Date();
	@Output() backEvent = new EventEmitter();
	reportdata :any[] = [];
	@Input() isout:boolean | undefined = false;
	@Input() viewsize: [number, number] = [600, 600];

	// options
	showXAxis: boolean = true;
	showYAxis: boolean = true;
	gradient: boolean = false;
	showLegend: boolean = true;
	showXAxisLabel: boolean = true;
	yAxisLabel: string = 'Country';
	showYAxisLabel: boolean = true;
	xAxisLabel: string = 'Population';
	colorScheme = 		{
		name: 'vivid',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: [
			'#e85c25','#f0a617','#95c429','#348146','#15a9a8','#00aeef','#005794','#a14572'
		]
	  }
	currentDate : string = '';
	startDate: Date = new Date();
	endDate: Date = new Date();
	ngOnInit() { 
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		}else {
			this.getDeviceReports();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if(changes.outstartDate){
			this.outstartDate = new Date(changes.outstartDate.currentValue);
			console.log(this.outstartDate);
			const today = new Date()
			let day = 86400000
			this.endDate = new Date(this.outstartDate.getTime() + (90 * day));
			if(!this.isout)
				this.startDate = new Date(today.getTime() - (365 * day));
			else
				this.startDate = this.outstartDate;
				this.endDate = this.outendDate;
				if(this.schoolId != -1){
					this.getSchoolReports()
				}else if(this.projectId != -1){
					this.getProjectReports();
				}else {
					this.getDeviceReports();
				}

	}
	}

	private getDateString(day:Date){
		if(day == null) day = new Date();
		return this.datePipe.transform(day, 'yyyy-MM-dd')!;
	}

	onSelectDate(){
		if(this.schoolId != -1){
			this.getSchoolReports()
		}else if(this.projectId != -1){
			this.getProjectReports();
		}else {
			this.getDeviceReports();
		}
	}

	private getSchoolReports(){
		this.service.analyticsGetSubjectSchoolReportPost(this.schoolId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		});
	}

	private getProjectReports(){
		this.service.analyticsGetSubjectProjectReportPost(this.projectId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		});
	}

	private getDeviceReports(){
		this.service.analyticsGetSubjectDeviceReportPost(this.deviceId,this.getDateString(this.startDate),this.getDateString(this.endDate)).subscribe(data=>{
			this.prepareData(data)
		});
	}

	private prepareData(data:any[]){
		let currentdata:any[] = [];
		data.forEach(item =>{
			currentdata.push(this.getData(item.subject!,item.count!));
		});
		this.reportdata = currentdata;
		//this.customColors = this.pieCustomColors();
	}
		


	navigateBack(){
		this.backEvent.next(null);
	}

	constructor(private service: AnalyticsService, private datePipe: DatePipe) {
		const today = new Date()
		let day = 86400000
		this.startDate = new Date(today.getTime() - (3 * 30 * day));
	}

	  getData(day: string, count: number){
		  return  {name:day,value:count};
	  }

	  pieCustomColors() {
		let result: any[] = [];
		for (let i = 0; i < this.reportdata.length; i++) {
		   if (this.reportdata[i].value < 200) {
			  result.push({"name": this.reportdata[i].name,"value": "#4F94D3"});
		   }
		}
		return result;
	 }

}